import React, { useState, useMemo, useRef, useContext } from "react";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";

export default () => (
	<Button
		id="campaign-sidesheet-button"
		icon="icon-download"
		size={BUTTON_SIZE.MEDIUM}
		display={BUTTON_DISPLAY.SECONDARY}
		onClick={() => {
			document.getElementById("open-sidesheet").click();
		}}
		data-tracking-id-alt="campaign-download-button"
	>
		Campaign Download
	</Button>
);
